"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.concat.js");

var _is = _interopRequireDefault(require("../is"));

/**
 * @function typevalue - 矫正类型函数
 * @param {any} origin 要矫正数据
 * @param {string} type 要矫正为的类型，有6中类型：'number', 'string', 'boolean', 'object', 'array', 'function'
 * @example
 * import { typevalue } from '@zz-biz/utils';
 * 
 * 
 * typevalue(null, [1, 2, 3, 4]); //[1, 2, 3, 4]
 * typevalue([5, 6, 7], [1, 2, 3, 4]); //[5, 6, 7]
 * typevalue(null, 'object'); //{}
 * typevalue(99, 'string'); // '99'
 * typevalue(99, 'heihei'); // '99'
 * typevalue(null, 'heihei'); // 'heihei'
 * typevalue([1, 2, 3], 'object'); // {}, error: 后端传值是array类型，你的类型是object类型，不匹配
 * typevalue('6666', 'number'); // 6666
 * typevalue('rrr6666', 'number'); // 0, error: 后端传值是string类型，你的类型是number类型，不匹配
 * 
 */
// 目前用于判断的类型数组
var optionalType = ['number', 'string', 'boolean', 'object', 'array', 'function'];
/*
 * 判断值的类型
 * @param type: any 传入的值 
 * @return 类型对应值
*/

var judgeType = function judgeType(type) {
  var typeName;

  if (type === 'number' || typeof type === 'number') {
    typeName = 'number';
  } else if (type === 'string' || typeof type === 'string' && !optionalType.includes(type)) {
    typeName = 'string';
  } else if (type === 'boolean' || typeof type === 'boolean') {
    typeName = 'boolean';
  } else if (type === 'object' || type instanceof Object && !(type instanceof Array)) {
    typeName = 'object';
  } else if (type === 'array' || _is["default"].Array(type)) {
    typeName = 'array';
  } else if (type === 'function' || _is["default"].Function(type)) {
    typeName = 'function';
  } else {
    typeName = 'null';
  }

  return typeName;
};
/*
 * 当源值为空时，为用户传入的类型默认初始值
 * 1、用户传类型的string值，如number等，设置改类型的空值
 * 2、用户直接传类型的初始值，取用户传的值，如number型，用户传3，初始值是3
 * @param type: any  用户传入的类型
 * @return 类型对应值值
*/


var setTypeValue = function setTypeValue(type) {
  var value;

  if (type === 'number') {
    value = 0;
  } else if (typeof type === 'number') {
    value = type;
  } else if (type === 'string') {
    value = '';
  } else if (typeof type === 'string' && !optionalType.includes(type)) {
    value = type;
  } else if (type === 'boolean') {
    value = false;
  } else if (typeof type === 'boolean') {
    value = type;
  } else if (type === 'object') {
    value = {};
  } else if (type instanceof Object && !(type instanceof Array)) {
    value = type;
  } else if (type === 'array') {
    value = [];
  } else if (_is["default"].Array(type)) {
    value = type;
  } else if (type === 'function') {
    value = function value() {};
  } else if (_is["default"].Function(type)) {
    value = type;
  } else {
    value = '';
  }

  return value;
};
/*
 * origin:any 要检测的原始值
 * type: any  要转换的类型
*/


var _default = function _default(origin, type) {
  var target;

  try {
    // 值为null、undefined、NaN及相应类型的空等, 按照想要的类型转换
    if (!origin && origin !== 0) {
      target = setTypeValue(type); // 值不为空, 提供数字类型和字符串类型的相互转化
    } else {
      if (judgeType(type) === judgeType(origin)) {
        // 类型一致
        // 对象类型返回新的数据
        if (judgeType(origin) === 'object' || judgeType(origin) === 'array') {
          target = JSON.parse(JSON.stringify(origin));
        } else {
          target = origin;
        } // 数字转字符串

      } else if (judgeType(type) === 'string' && judgeType(origin) === 'number') {
        target = origin.toString(); // 字符串转数字
      } else if (judgeType(type) === 'number' && judgeType(origin) === 'string') {
        if (/^(\d+)$/.test(origin)) {
          // 全是数字转
          target = Number(origin);
        } else {
          // 不是数字，取传的默认值
          target = setTypeValue(type);
          console.error('后端传值是string类型，你需要的是number类型，不匹配');
        }
      } else {
        target = setTypeValue(type);
        console.error("\u540E\u7AEF\u4F20\u503C\u662F".concat(judgeType(origin), "\u7C7B\u578B\uFF0C\u4F60\u9700\u8981\u7684\u662F").concat(judgeType(type), "\u7C7B\u578B\uFF0C\u4E0D\u5339\u914D"));
      }
    }

    return target;
  } catch (err) {
    console.warn(err);
    target = setTypeValue(type);
    return target;
  }
};

exports["default"] = _default;